// Avatar helpers — initials + a deterministic colour, shown when a user has no
// uploaded avatar image. Shared by the sidebar, the profile menu and /personal/settings.

/** 1–2 uppercase initials from a profile ({firstName,lastName,email} or the auth user). */
export function initials(p) {
  const first = (p?.firstName || p?.first_name || '').trim();
  const last = (p?.lastName || p?.last_name || '').trim();
  if (first && last) return (first[0] + last[0]).toUpperCase();
  if (first) return first.slice(0, 2).toUpperCase();
  const email = (p?.email || '').trim();
  return (email[0] || '?').toUpperCase();
}

/** Full display name, or the email when no name is set. */
export function displayName(p) {
  const name = [p?.firstName || p?.first_name, p?.lastName || p?.last_name]
    .filter(Boolean).join(' ').trim();
  return name || p?.email || '';
}

// A small, pleasant palette; pick deterministically so a user's colour is stable.
const AVATAR_COLORS = ['#C2255C', '#7048E8', '#1C7ED6', '#0CA678', '#E8590C', '#5F3DC4', '#2B8A3E', '#1098AD'];

/** Stable background colour for the initials avatar, derived from a seed string. */
export function avatarColor(seed) {
  const s = String(seed || '');
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
